import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import logoLight from "url:asset/logo_light.svg";
import logoDark from "url:asset/logo_dark.svg";

// Shell for the universal link fallback pages (login, team invites). Someone
// only lands on one of these when the app isn't installed to catch the link,
// so every variant ends with the store links.

const IOS_APP_STORE_URL =
  "https://apps.apple.com/us/app/salt-church-companion/id1614084359";

const ANDROID_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.saltplatform.salt_android";

export default function AppHandoff(props: {
  heading: string,
  instructions: string,
  children?: ReactNode,
}) {
  const { t } = useTranslation("appHandoff");

  return <main className="min-h-screen flex flex-col items-center justify-center gap-6 p-8">
    <div className="flex flex-col items-center gap-3 text-center">
      <picture>
        <source srcSet={logoDark} media="(prefers-color-scheme: dark)" />
        <img src={logoLight} alt="Salt" className="w-32 md:w-40 mb-2" />
      </picture>

      <h1 className="text-3xl md:text-5xl font-semibold">{props.heading}</h1>
      <p className="text-lg text-gray-600 max-w-prose">
        {props.instructions}
      </p>
    </div>

    {props.children}

    <div className="flex flex-col sm:flex-row items-center gap-3">
      <StoreLink label={t("downloadIos")} href={IOS_APP_STORE_URL} />
      <StoreLink label={t("downloadAndroid")} href={ANDROID_PLAY_STORE_URL} />
    </div>
  </main>
}

function StoreLink(props: { label: string, href: string }) {
  const base = "py-3 px-6 rounded-full text-lg font-medium text-center w-full max-w-80 sm:w-auto whitespace-nowrap";

  return <a
    href={props.href}
    className={`${base} select-none bg-accent text-white hover:opacity-75 transition-opacity duration-300`}
  >
    {props.label}
  </a>
}
